module.exports = __webpack_public_path__ + "static/img/004-BA.21b5c4ad.png";